import { idbGet, idbSet, idbDelete } from './idb';
import { createLogger } from '@/lib/logger';

const log = createLogger('BaseStore');

const KEY = 'current_base';

export type BaseType = 'local' | 'remote';

export interface CurrentBase {
  id: string;
  url: string;
  type: BaseType;
  name: string;
}

export async function baseStoreGet(): Promise<CurrentBase | undefined> {
  return idbGet<CurrentBase>(KEY);
}

export async function baseStoreSet(base: CurrentBase): Promise<void> {
  if (!base.id) {
    log.warn('baseStoreSet called without base id');
    return;
  }
  await idbSet(KEY, base);
}

export async function baseStoreClear(): Promise<void> {
  await idbDelete(KEY);
}
